import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE;

const apiClient = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
});

// Attach auth token
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * Submit RLHF feedback for a Tacia response.
 * @param {Object} data
 * @param {string} data.chat_history_id - ID of the chat message
 * @param {string} data.agent_id - Agent ID
 * @param {string} data.question - The user's question
 * @param {string} data.answer - Tacia's answer
 * @param {string} data.rating - "up" or "down"
 * @param {string|null} data.error_tag - Error category tag
 * @param {string|null} data.comment - Optional correction/comment
 * @param {string|null} data.intent - Detected intent
 */
export const submitFeedback = async (data) => {
  const res = await apiClient.post("/agent/feedback", data);
  return res.data;
};
